<template>
   <div class='bat-analysis'>
      <form @submit.prevent="()=>{}">
         <input-field
            type="select"
            v-model='period'
            :options="periodOptions"
            label="Project Period (Year)"
            :errors="errors.period"
            one-line
            label50
         />
         <input-field
            type="number"
            v-model='extensionLimit'
            label="Grid Extension Limit(Km)"
            :errors="errors.gridExtensionLimit"
            :extraAttributes="{min:1, max: 15}"
            one-line
            label50
         />
         <hr>
         <div class='constant'>
            <span>Distance from Grid (Km)</span>
            <span class="value">{{ getBatResults && getBatResults.distance_to_grid_ext_km }} km</span>
         </div>
         <div class='constant'>
            <span>Distance from nearest MHP (Km)</span>
            <span class="value">{{ getBatResults && getBatResults.distance_to_mhp_km }} km</span>
         </div>
         <div v-if="showGridExtensionPlan">
            <hr>
            <input-field
               type="checkbox"
               v-model='isExtendingGrid'
               label="Grid Extension Plan"
               :errors="[]"
               one-line
               label50
            />
            <input-field
               v-if="isExtendingGrid"
               type="select"
               v-model='extensionPeriod'
               :options="extensionPeriodOptions"
               label="Project Period (Year)"
               :errors="errors.extensionPeriod"
               one-line
               label50
            />
         </div>
      </form>
      <bat-analysis-energy-costs
         :feasible-energies="energyCostWithBestOption"
      />
   </div>
</template>

<script>
import InputField from '../../../../molecules/Login/InputField';
import BatAnalysisEnergyCosts from '../../../../organisms/Home/BatAnalysisEnergyCosts';
import { mapGetters } from 'vuex';

export default {
   name: 'bat-analysis',
   components: {
      InputField,
      BatAnalysisEnergyCosts
   },
   data() {
      const periodOptions = [5,10,15].map(value => ({title: value, value}));
      const extensionPeriodOptions = ['> 5 years', '< 5 Years'].map(value =>({title: value, value}) );
      return {
         period: 5,
         periodOptions,
         extensionLimit: 1,
         extensionPeriod: '> 5 years',
         extensionPeriodOptions,
         isExtendingGrid: false,
         errors: {
            period: [],
            gridExtensionLimit: [],
            extensionPeriod: [],
         }
      }
   },
   computed: {
      ...mapGetters(['getBatResults']),
      showGridExtensionPlan()
      {
         if (!this.getBatResults) return false;
         return this.getBatResults.distance_to_grid_ext_km <= this.extensionLimit;
      },
      energyCosts()
      {
         const results = this.getBatResults;
         if (results)
         {
            const nameSeriesMap = {
               'Solar Home System': results.energy_costs.shs.cost_series,
               'Grid Extension': results.energy_costs.grid.cost_series,
               'Solar Mini-Grid': results.energy_costs.solar_minigrid.cost_series,
            };
            if (!results.is_in_terai)
            {
               nameSeriesMap['Micro-Hydro Power'] = results.energy_costs.mhp.cost_series;
            }
            const yearIndex = this.period - 1;
            const currEnergyCosts = (Object.entries(nameSeriesMap)).map(([name, series]) =>
            {
               return {
                  name,
                  lcc: series.life_cycle_costs[yearIndex],
                  lcoe: series.levelized_costs[yearIndex],
               };
            });
            return currEnergyCosts
         }
         return [];
      },
      energyCostWithBestOption()
      {
         // sort costs by lcc in asc order
         const sortedCosts = [...this.energyCosts].sort((cost1, cost2) => {
            if (cost1.lcc > cost2.lcc) return 1;
            if (cost1.lcc < cost2.lcc) return -1;
            return 0;
         });
         if (this.showGridExtensionPlan && this.isExtendingGrid && this.extensionPeriod==='< 5 Years')
         {
            // if we are extending grid but grid extension period is < 5 yrs, SHS is the best options
            return sortedCosts.map(cost => ({...cost, isBestOption: cost.name==='Solar Home System'}));
         }
         // energy with the lowest lcc isBestOption
         return sortedCosts.map((cost,index) => ({...cost, isBestOption:(index===0) })); 
      }
   },
}
</script>

<style lang="scss" scoped>
.bat-analysis {
   background-color: white;
   padding: 0.4rem 1rem;
   border-radius: 5px;
}
.constant {
   margin: 0.65rem 0;
   color: $font-color;
   > span {
      line-height: 2;
      font-size: 0.9em;
      display: inline-block;
      width: 50%;
   }
   .value {
      font-weight: 600;
      padding-left: 0.45em;
   }
}
</style>
